import { Box, Typography } from '@vp/swan'
import { useEffect, useState } from 'react'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import { Article } from '../../types/article.type'
import './ArticleContent.scss'

interface ArticleContentProps {
  article: Article
}
export const ArticleContent = ({ article }: ArticleContentProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(0)
  const [imageUrls, setImageUrls] = useState<string[]>([])
  const [articleWidth, setArticleWidth] = useState('98%')
  const handleOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const { tagName } = e.target as HTMLElement
    if (tagName === 'IMG') {
      const { src } = e.target as HTMLImageElement
      const index = imageUrls.indexOf(src)
      if (index >= 0) {
        setPhotoIndex(index)
        setIsOpen(true)
      }
    }
  }
  useEffect(() => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(article.articleBody, 'text/html')
    const images = Array.from(doc.getElementsByTagName('img')) as HTMLImageElement[]

    if (images.length) {
      setImageUrls(images.map((img) => img.src))
    }
  }, [article])

  useEffect(() => {
    const minScreenWidthXs = 768
    const screenWidthMd = 1024
    if (window && window.innerWidth >= minScreenWidthXs && window.innerWidth < screenWidthMd) {
      // if screen is sm
      setArticleWidth('98%')
    } else if (window && window.innerWidth >= screenWidthMd) {
      // if screen is md or lg
      setArticleWidth('95%')
    }
  }, [])

  return (
    <div style={{ width: '-webkit-fill-available', overflow: 'hidden' }}>
      <Typography fontSkin="title-section" style={{ width: articleWidth }}>
        {article.articleTitle}
      </Typography>
      <Box mb={7} />
      <div>
        <div
          className="content text-size-5 article-content"
          style={{ width: articleWidth }}
          dangerouslySetInnerHTML={{ __html: article.articleBody }}
          onClick={handleOnClick}
        />

        {isOpen && <Lightbox open={isOpen} close={() => setIsOpen(false)} slides={imageUrls.map((src) => ({ src }))} index={photoIndex} />}
      </div>
    </div>
  )
}
